/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class ERCOTDayAheadPrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "ERCOTDayAheadPrices";
}

const servicePlugin = makeServicePlugin({
  Model: ERCOTDayAheadPrices,
  service: feathersClient.service("data-services/ercot/day-ahead-locational-marginal-prices"),
  idField: "Bus Name",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
